import {Button} from "@headlessui/react";
import {ChevronLeftIcon} from "@chakra-ui/icons";

export const PartHeader = ({goBack, step, title, description}) => (
  <div className='flex gap-2 flex-col w-full px-2  sm:px-0'>
    <Button onClick={goBack ? goBack : undefined} className='flex items-center text-brand'>
      <ChevronLeftIcon className='text-brand fill-brand' boxSize={8} />
      <span className='text-brand text-lg'>{step > 0 ? 'Previous step' : 'Back'}</span>
    </Button>
    <div className='flex gap-2 items-center'>
      <div className='h-[60px] w-[60px] border border-brand rounded-full flex items-center justify-center'>
        <span className='font-bold text-3xl'>{step + 1}</span>
      </div>
      <div className='flex flex-col gap-1'>
        <h1 className='text-xl font-bold'>{title}</h1>
        <span className='text-brand-alt text-sm'>{description}</span>
      </div>
    </div>
  </div>
)
